import { capitalize, sortBy } from 'lodash';
import { PolicyDocumentType, PolicyState, PolicyStatus } from '../../shared/generated';
import { getLocalTranslation } from '../../utils/i18nKit';
export var getPolicyStateTypeMap = function getPolicyStateTypeMap() {
  var stateMap = {};
  var list = [];
  Object.keys(PolicyState).forEach(function (key) {
    var _PolicyState$key;

    list.push({
      value: PolicyState[key],
      label: capitalize((_PolicyState$key = PolicyState[key]) === null || _PolicyState$key === void 0 ? void 0 : _PolicyState$key.replaceAll('_', ' '))
    });
  });
  list = sortBy(list, 'label');
  list.forEach(function (key) {
    stateMap[key.value] = key;
  });
  return stateMap;
};
export var getPolicyStateTypeList = function getPolicyStateTypeList() {
  return Object.values(getPolicyStateTypeMap());
};
export var getRealDisplatPolicyStateTypeList = function getRealDisplatPolicyStateTypeList() {
  return getPolicyStateTypeList().filter(function (item) {
    return ![PolicyState.POLICY_ERROR].includes(item.value);
  });
};
export var getPolicyStatusTypeMap = function getPolicyStatusTypeMap() {
  var statusMap = {};
  var list = [];
  Object.keys(PolicyStatus).forEach(function (key) {
    var _PolicyStatus$key;

    var name = capitalize((_PolicyStatus$key = PolicyStatus[key]) === null || _PolicyStatus$key === void 0 ? void 0 : _PolicyStatus$key.replaceAll('_', ' '));

    if (![PolicyStatus.POLICY_RENEWED].includes(PolicyStatus[key])) {
      name = name.replaceAll('renewed', 'renew');
    }

    list.push({
      value: PolicyStatus[key],
      label: name
    });
  });
  list = sortBy(list, 'label');
  list.forEach(function (key) {
    statusMap[key.value] = key;
  });
  return statusMap;
};
export var getPolicyStatusTypeList = function getPolicyStatusTypeList() {
  return Object.values(getPolicyStatusTypeMap());
};
export var getRealDisplayPolicyStatusTypeList = function getRealDisplayPolicyStatusTypeList() {
  return getPolicyStatusTypeList().filter(function (item) {
    return ![PolicyStatus.POLICY_EXTENDED, PolicyStatus.POLICY_EXTENDED_INITIATED, PolicyStatus.POLICY_EXTENSION_TRIGGER, PolicyStatus.POLICY_PAUSE_EXTENDED, PolicyStatus.POLICY_PAUSE_INITIATED, PolicyStatus.POLICY_PAUSE_PLANNED, PolicyStatus.POLICY_PROSPECT, PolicyStatus.POLICY_PROSPECT_INITIATED, PolicyStatus.POLICY_RENEW_TRIGGER, PolicyStatus.POLICY_SWITCH_TO_ANNUAL_INITIATED, PolicyStatus.POLICY_SWITCHER, PolicyStatus.POLICY_SWITCHER_INITIATED, PolicyStatus.POLICY_UNPAUSED].includes(item.value);
  });
};
export var getPolicyDocumentTypeMap = function getPolicyDocumentTypeMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    WOR: {
      value: PolicyDocumentType.WOR,
      label: $t('kit:policy_doc_types.policy_wording')
    },
    SOC: {
      value: PolicyDocumentType.SOC,
      label: $t('kit:policy_doc_types.summary_of_cover')
    },
    SCH: {
      value: PolicyDocumentType.SCH,
      label: $t('kit:policy_doc_types.schedule')
    },
    QSCH: {
      value: PolicyDocumentType.QSCH,
      label: $t('kit:policy_doc_types.quote_schedule')
    },
    SOF: {
      value: PolicyDocumentType.SOF,
      label: $t('kit:policy_doc_types.statement_of_fact')
    },
    IPD: {
      value: PolicyDocumentType.IPD,
      label: $t('kit:policy_doc_types.insurance_policy_document')
    },
    CER: {
      value: PolicyDocumentType.CER,
      label: $t('kit:policy_doc_types.certificate_of_insurance')
    },
    IPID: {
      value: PolicyDocumentType.IPID,
      label: $t('kit:policy_doc_types.insurance_product_information_document')
    },
    PI: {
      value: PolicyDocumentType.PI,
      label: $t('kit:policy_doc_types.combined_pi')
    },
    TOBA: {
      value: PolicyDocumentType.TOBA,
      label: $t('kit:policy_doc_types.terms_of_business')
    },
    INVOICE: {
      value: PolicyDocumentType.INVOICE,
      label: $t('kit:policy_doc_types.invoice')
    },
    APPLICATION_FORMS: {
      value: PolicyDocumentType.APPLICATION_FORMS,
      label: $t('kit:policy_doc_types.application_forms')
    }
  };
};
export var getPolicyDocumentTypeList = function getPolicyDocumentTypeList() {
  return Object.values(getPolicyDocumentTypeMap());
};